import { usePathname } from '@/hooks/common/usePathname'

export const useIsOnboarding = () => {
  const pathname = usePathname()
  return { isOnboarding: pathname?.startsWith('/welcome') ?? false }
}
